<script>
    import { navigate }         from "svelte-routing"
    import _                    from 'lodash'
    import { company, domains } from '../../shared/stores.js'
    import DomainDropdown       from '../../shared/DomainDropdown.svelte'
    import SectionTitle         from '../../shared/SectionTitle.svelte'
    import AppLoader            from '../../shared/Loader.svelte'
    import ConsentFilter        from './ConsentFilter.svelte'
    import ConsentAssignment    from './ConsentAssignment.svelte'
    
    let domain      = null
    let loading     = false
    let error       = false
    let buffer      = []
    let filter      = {}
    let queryError  = false
    let currentItem = null

    const match = /empresa\/([0-9]+)\/consentimentos\/(.+)/.exec(window.location)
    if(match) {
        domain = $domains.find(it => it.domain === match[2])    
    }
 
    function onDomainSelected(selected) {
        domain = selected ? selected.value : null
        if(domain) {
            navigate(`/empresa/${$company.id}/consentimentos/${domain.domain}`)
        } else {
            navigate(`/empresa/${$company.id}/consentimentos`)
        }
    }

    function iconGiven(item) {
        if(item.agreement) {
            return item.agreement.accepted ? 'green check circle outline' : 'red ban' 
        } else {
            return 'disabled circle outline'
        }
    }

    function originGiven(item) {
        if(item.agreement) {
            switch(item.agreement.evidenceType) {
                case "SD" : return "documento assinado"
                case "EF" : return "formulário externo"
                case "PC" : return "central da privacidade"
                default   : return "desconhecido"
            }
        }
    }

    function enableEvidenceUpload(item) {
        return e => {
            currentItem = item
        }
    }

    function evidenceGiven(item) {
        const sd = evidence => {
            if(evidence && evidence.endsWith('.pdf')) {
                return { icon: "file pdf outline" }
            } else {
                return { icon: "file image outline" }
            }
        }
        if (item.agreement) {
            switch (item.agreement.evidenceType) {
                case "SD" : return sd(item.agreement.evidence)
                default   : return null 
            }
        }
    }

    function downloadEvidence(item) {
        return e => {
            console.log("Download", item)
        }
    }

</script>

<svelte:head>
	<title>Dogma / {$company.name} / Consentimentos</title>
</svelte:head>

{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Consentimentos
    </SectionTitle>

    <DomainDropdown {domain} {onDomainSelected} />

    {#if !domain}
        <div class="ui big message">
            Selecione um domínio
        </div>
    {:else}
        <div class="ui raised segments">
            <div class="ui segment">
                <div class="places">
                    <h2 class="ui header">Consentimentos</h2>
                    <ConsentFilter {domain} bind:error={queryError} bind:buffer bind:filter></ConsentFilter>
                </div>
            </div>
            <div class="ui segment">
                {#if buffer.length > 0}
                    <table class="ui padded large table">
                        <thead>
                            <tr>
                                <th class="two wide"   > Consentimento </th>
                                <th class="three wide" > Data          </th>
                                <th class="five wide"  > Atividade     </th>
                                <th class="two wide"   > Origem        </th>
                                <th class="two wide"   > Evidência     </th>
                                <th class="two wide"   >               </th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each buffer as item}
                                {@const evidence = evidenceGiven(item)}
                                <tr>
                                    <td><i class="{iconGiven(item)} icon"></i></td>
                                    <td>{item.agreement ? item.agreement.on : ''}</td>
                                    <td>{item.requirement.title}</td>
                                    <td>
                                        {originGiven(item) || ''}
                                    </td>
                                    <td>
                                        {#if evidence}
                                            <i class="{evidence.icon} ui link icon" on:click={downloadEvidence(item)}></i>
                                        {/if}
                                    </td>
                                    <td>
                                        <button class="ui button" 
                                                class:disabled={item.agreement || !filter.email}
                                                on:click={enableEvidenceUpload(item)}>Adicionar Evidência</button>
                                    </td>
                                </tr>
                            {/each}
                        </tbody>                        
                    </table>
                {:else if queryError}
                    Erro na busca. Por favor, preencha uma das duas opções de filtro acima
                {:else}
                    Nenhum resultado
                {/if}
            </div>        
        </div>
        <ConsentAssignment
            {domain}
            email={filter.email} 
            display={currentItem != null}
            selected={[currentItem]}
            bind:activities={buffer}/>
    {/if}
{/if}